import { useState } from "react";
import { useEffect } from "react";
import cross from "./cross.png"
import O from "./o.png"
import "./room.scss"
import restart from "./restart.png"
import square from "./square.png"
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import check from "./check.png"
import cancel from "./cancel.png"
import userP from "./user.png"
import { useNavigate, useParams } from "react-router-dom";
import { useCollection, useCollectionData } from "react-firebase-hooks/firestore";

firebase.initializeApp({
    apiKey: "AIzaSyAnzYwQZoS92SwESEjZyjMclAn8mq_mMZ4",
    authDomain: "tactime-5f55b.firebaseapp.com",
    projectId: "tactime-5f55b",
    storageBucket: "tactime-5f55b.appspot.com",
    messagingSenderId: "312243494453",
    appId: "1:312243494453:web:0be469bcd3bfdaa1479b7c",
    measurementId: "G-XGCTXHET5H"
})

const auth = firebase.auth();
const firestore = firebase.firestore();

function Room() {

    const [state, setState] = useState(false);
    const { roomId } = useParams()
    const [showGameBox, setShowGameBox] = useState(false)
    const navigate = useNavigate()

    const [currentTurn, setCurrentTurn] = useState(1); // 1 for player 1, 2 for player 2
    const [timerActive, setTimerActive] = useState(false);
    const [remainingTime, setRemainingTime] = useState(60); // Initial time in seconds
    const switchTurn = () => {
        setCurrentTurn((prevTurn) => (prevTurn === 1 ? 2 : 1));
    };


    const [turn, setTurn] = useState(""); // Store the turn value

    const [mid, setMid] = useState("")
    const [oid, setOid] = useState("")
    const [cid, setCid] = useState("")
    const [num, setNum] = useState(0)



    useEffect(() => {
        if (roomId) {
            const roomRef = firestore.collection("rooms").doc(roomId);
            roomRef.onSnapshot((doc) => {
                if (doc.exists) {
                    const roomData = doc.data();
                    setTurn(roomData.turn); // Assuming 'turn' is a field in the Firestore document
                    setOid(roomData.ouid)

                    roomData.turn == roomData.ouid ? setCid(roomData.muid) : setCid(roomData.ouid)
                    setNum(roomData.num)
                }
            });
        }
    }, [roomId]);

    // Function to enable/disable pointer events based on 'turn'
    const togglePointerEvents = (turnMatches) => {
        const gameElement = document.getElementById('game'); // Replace with the actual class name of your game element

        if (gameElement) {
            gameElement.style.pointerEvents = turnMatches ? 'auto' : 'none';
            document.getElementById("box1").style.pointerEvents = turnMatches ? 'auto' : 'none'
            document.getElementById("box2").style.pointerEvents = turnMatches ? 'auto' : 'none'
            document.getElementById("box3").style.pointerEvents = turnMatches ? 'auto' : 'none'
            document.getElementById("box4").style.pointerEvents = turnMatches ? 'auto' : 'none'
            document.getElementById("box5").style.pointerEvents = turnMatches ? 'auto' : 'none'
            document.getElementById("box6").style.pointerEvents = turnMatches ? 'auto' : 'none'
            document.getElementById("box7").style.pointerEvents = turnMatches ? 'auto' : 'none'
            document.getElementById("box8").style.pointerEvents = turnMatches ? 'auto' : 'none'
            document.getElementById("box9").style.pointerEvents = turnMatches ? 'auto' : 'none'
        }

    };

    // Call togglePointerEvents whenever 'turn' changes
    useEffect(() => {
        if (showGameBox) {
            togglePointerEvents(turn === auth.currentUser.uid)
        }

    }, [turn, showGameBox]);





    // Initialize your state variables
    const [oneValue, setOneValue] = useState("none");
    const [twoValue, settwoValue] = useState("none");
    const [threValue, setthreValue] = useState("none");
    const [fourValue, setfourValue] = useState("none");
    const [fiveValue, setfiveValue] = useState("none");
    const [sixValue, setsixValue] = useState("none");
    const [sevenValue, setsevenValue] = useState("none");
    const [eigthValue, seteigthValue] = useState("none");
    const [nineValue, setnineValue] = useState("none");


    const romRef = firestore.collection("rooms")
    const [roomY] = useCollectionData(romRef)

    const memRef = firestore.collection("rooms").doc(roomId).collection("members")
    const [mems] = useCollectionData(memRef)

    const boxesRef = firestore.collection("rooms").doc(roomId).collection("boxes")
    const [boxes] = useCollectionData(boxesRef)

    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        boxes && boxes.map((b) => (
            setOneValue(b.box1),
            settwoValue(b.box2),
            setthreValue(b.box3),
            setfourValue(b.box4),
            setfiveValue(b.box5),
            setsixValue(b.box6),
            setsevenValue(b.box7),
            seteigthValue(b.box8),
            setnineValue(b.box9)
        ))


    }, [boxes])



    useEffect(() => {
        roomY && roomY.map((rd) => (
            rd.rid == roomId
                ? rd.members > 1
                    ? (
                        setShowGameBox(true),
                        setIsLoading(false)
                    )
                    : (
                        setShowGameBox(false),
                        setIsLoading(false)
                    )
                : null
        ))
    }, [roomY])

    const clicked = (z, t) => {
        if (currentTurn === 1) {
            // Only allow the current player to make a move
            imageSet(z, t);

        }
    };


    const imageSet = async (y, x) => {
        roomY && roomY.map(async (rmf) => (

            rmf.rid == roomId
                ?
                (
                    rmf.stateT
                        ? (
                            firestore.collection("rooms").doc(roomId).set({
                                stateT: false,
                                turn: cid,
                                num: firebase.firestore.FieldValue.increment(1)

                            }, { merge: true }),

                            firestore.collection("rooms").doc(roomId).collection("boxes").doc("values").set({
                                [x]: cross
                            }, { merge: true }),




                            firestore.collection("rooms").doc(roomId).collection("boxes").doc("values").set({
                                [y]: "cross"
                            }, { merge: true }),
                            await setNum(num + 1),


                            document.getElementById(y).style.pointerEvents = "none"
                        )
                        : (
                            firestore.collection("rooms").doc(roomId).set({
                                stateT: true,
                                turn: cid,
                                num: firebase.firestore.FieldValue.increment(1)
                            }, { merge: true }),

                            firestore.collection("rooms").doc(roomId).collection("boxes").doc("values").set({
                                [x]: O
                            }, { merge: true }),
                            document.getElementById(y).style.pointerEvents = "none",
                            firestore.collection("rooms").doc(roomId).collection("boxes").doc("values").update({
                                [y]: "zero"
                            })

                        )
                )
                : null

        ))

    }

    const leaveRoom = async () => {
        firestore.collection("rooms").doc(roomId).collection("members").doc(auth.currentUser.uid).delete()
        firestore.collection("rooms").doc(roomId).set({
            members: 1,
            muid: "",
            turn: oid,
            result: "Awaited",
            num: 0
        }, { merge: true })



        await setOneValue("none")
        await settwoValue("none")
        await setthreValue("none")
        await setfourValue("none")
        await setfiveValue("none")
        await setsixValue("none")
        await setsevenValue("none")
        await seteigthValue("none")
        await setnineValue("none")


        await firestore.collection("rooms").doc(roomId).update({
            stateT: true
        })




        await firestore.collection("rooms").doc(roomId).collection("boxes").doc("values").set({
            box1: "none",
            box2: "none",
            box3: "none",
            box4: "none",
            box5: "none",
            box6: "none",
            box7: "none",
            box8: "none",
            box9: "none",
            box1src: square,
            box2src: square,
            box3src: square,
            box4src: square,
            box5src: square,
            box6src: square,
            box7src: square,
            box8src: square,
            box9src: square

        })



        navigate("/")


    }

    const deleteRoom = async () => {
        firestore.collection("rooms").doc(roomId).delete()
        navigate("/")
    }


    const rooomRef = firestore.collection("rooms")
    const [roooms] = useCollectionData(rooomRef)


    const joinRoom = async (x, e) => {
        e.preventDefault()
        roooms && roooms.map(async (r) => (
            r.rid == x.rid
                ? r.members == 2
                    ? alert("A room can't consist of more than 2 people. Please remove one then play with other friends or create another room")
                    : (
                        firestore.collection("rooms").doc(x.rid).collection("members").doc(x.uid).set({
                            name: x.name,
                            uid: x.uid,
                            owner: "no",
                            member: "yes"
                        }),

                        firestore.collection("rooms").doc(x.rid).set({
                            members: 2,
                            muid: x.uid,
                            turn: oid,
                            result: "Awaited",
                            num: 0
                        }, { merge: true }),
                        firestore.collection("rooms").doc(x.rid).collection("requests").doc(x.uid).delete()
                    )

                : null
        ))
    }



    const removeMem = async (x) => {
        firestore.collection("rooms").doc(roomId).collection("members").doc(x.uid).delete()
        firestore.collection("rooms").doc(roomId).set({
            members: 1,
            muid: "",
            turn: oid,
            result: "Awaited",
            num: 0
        }, { merge: true })


        await setNum(1)

        await setOneValue("none")
        await settwoValue("none")
        await setthreValue("none")
        await setfourValue("none")
        await setfiveValue("none")
        await setsixValue("none")
        await setsevenValue("none")
        await seteigthValue("none")
        await setnineValue("none")


        await firestore.collection("rooms").doc(roomId).update({
            stateT: true
        })




        await firestore.collection("rooms").doc(roomId).collection("boxes").doc("values").set({
            box1: "none",
            box2: "none",
            box3: "none",
            box4: "none",
            box5: "none",
            box6: "none",
            box7: "none",
            box8: "none",
            box9: "none",
            box1src: square,
            box2src: square,
            box3src: square,
            box4src: square,
            box5src: square,
            box6src: square,
            box7src: square,
            box8src: square,
            box9src: square

        })


    }

    const deleteRqst = async (x, e) => {
        e.preventDefault()
        firestore.collection("rooms").doc(roomId).collection("requests").doc(x.uid).delete();
    }


    const reload = async () => {



        if (turn == auth.currentUser.uid) {
            document.getElementById("game").style.pointerEvents = "auto"
            document.getElementById("box1").style.pointerEvents = "auto"
            document.getElementById("box2").style.pointerEvents = "auto"
            document.getElementById("box3").style.pointerEvents = "auto"
            document.getElementById("box4").style.pointerEvents = "auto"
            document.getElementById("box5").style.pointerEvents = "auto"
            document.getElementById("box6").style.pointerEvents = "auto"
            document.getElementById("box7").style.pointerEvents = "auto"
            document.getElementById("box8").style.pointerEvents = "auto"
            document.getElementById("box9").style.pointerEvents = "auto"
        }
        else {
            document.getElementById("game").style.pointerEvents = "none"
            document.getElementById("box1").style.pointerEvents = "none"
            document.getElementById("box2").style.pointerEvents = "none"
            document.getElementById("box3").style.pointerEvents = "none"
            document.getElementById("box4").style.pointerEvents = "none"
            document.getElementById("box5").style.pointerEvents = "none"
            document.getElementById("box6").style.pointerEvents = "none"
            document.getElementById("box7").style.pointerEvents = "none"
            document.getElementById("box8").style.pointerEvents = "none"
            document.getElementById("box9").style.pointerEvents = "none"
        }


        await setNum(1)



        await setOneValue("none")
        await settwoValue("none")
        await setthreValue("none")
        await setfourValue("none")
        await setfiveValue("none")
        await setsixValue("none")
        await setsevenValue("none")
        await seteigthValue("none")
        await setnineValue("none")


        await firestore.collection("rooms").doc(roomId).update({
            stateT: true,
            turn: oid,
            result: "Awaited",
            num: 0
        })




        await firestore.collection("rooms").doc(roomId).collection("boxes").doc("values").set({
            box1: "none",
            box2: "none",
            box3: "none",
            box4: "none",
            box5: "none",
            box6: "none",
            box7: "none",
            box8: "none",
            box9: "none",
            box1src: square,
            box2src: square,
            box3src: square,
            box4src: square,
            box5src: square,
            box6src: square,
            box7src: square,
            box8src: square,
            box9src: square

        })




    }


    // Use useEffect to log state changes
    useEffect(() => {


        if ((oneValue == "cross" && twoValue == "cross" && threValue == "cross") || (fourValue == "cross" && fiveValue == "cross" && sixValue == "cross") || (sevenValue == "cross" && eigthValue == "cross" && nineValue == "cross") || (oneValue == "cross" && fourValue == "cross" && sevenValue == "cross") || (twoValue == "cross" && fiveValue == "cross" && eigthValue == "cross") || (threValue == "cross" && sixValue == "cross" && nineValue == "cross") || (oneValue == "cross" && fiveValue == "cross" && nineValue == "cross") || (threValue == "cross" && fiveValue == "cross" && sevenValue == "cross")) {
            firestore.collection("rooms").doc(roomId).update({
                result: "X won"
            })
            document.getElementById("game").style.pointerEvents = "none"
        }
        else if (
            (oneValue == "zero" && twoValue == "zero" && threValue == "zero") || (fourValue == "zero" && fiveValue == "zero" && sixValue == "zero") ||
            (sevenValue == "zero" && eigthValue == "zero" && nineValue == "zero") || (oneValue == "zero" && fourValue == "zero" && sevenValue == "zero") ||
            (twoValue == "zero" && fiveValue == "zero" && eigthValue == "zero") || (threValue == "zero" && sixValue == "zero" && nineValue == "zero") ||
            (oneValue == "zero" && fiveValue == "zero" && nineValue == "zero") || (threValue == "zero" && fiveValue == "zero" && sevenValue == "zero")) {
            firestore.collection("rooms").doc(roomId).update({
                result: "0 won"
            })
            document.getElementById("game").style.pointerEvents = "none"
        }
        else if (num == 9) {
            firestore.collection("rooms").doc(roomId).update({
                result: "Game draw"
            })
            document.getElementById("game").style.pointerEvents = "none"
        }
    }, [oneValue, twoValue, threValue, fourValue, fiveValue, sixValue, sevenValue, eigthValue, nineValue]);

    const rqstsRef = firestore.collection("rooms").doc(roomId).collection("requests")
    const [rqsts] = useCollectionData(rqstsRef)

    




    return (
        <div className='RoomMain'>
            {
                isLoading
                    ? <div className="spinner">
                        <br /><br />
                        <span class="loader"></span>
                    </div>
                    : (


                        roomY && roomY.map((r) => (
                            r.rid == roomId
                                ? r.ouid == auth.currentUser.uid || r.muid == auth.currentUser.uid
                                    ? <div>
                                        <br />

                                        {
                                            roomY && roomY.map((rd) => (
                                                rd.rid == roomId
                                                    ? <p className="tagline" >{rd.name}</p>
                                                    : null
                                            ))
                                        }

                                        <div className="game-page">
                                            <div className="left-part">
                                                <div className="members">
                                                    <p className="sub-tagline members-head">Members</p>

                                                    <div className="members-list">
                                                        {
                                                            mems && mems.map((md) => (
                                                                md.uid == auth.currentUser.uid
                                                                    ? <div className="member">
                                                                        <p className="room-name">You</p>
                                                                    </div>
                                                                    : <div className="member">
                                                                        <p className="room-name">{md.name}</p>
                                                                        {
                                                                            roomY && roomY.map((rt) => (
                                                                                rt.rid == roomId
                                                                                    ? rt.ouid == auth.currentUser.uid
                                                                                        ? <button onClick={() => { removeMem(md) }} className="join log-out" >Remove</button>
                                                                                        : null
                                                                                    : null
                                                                            ))
                                                                        }
                                                                    </div>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                                <br />
                                                {
                                                    r.ouid == auth.currentUser.uid
                                                        ? <div className="requests">

                                                            <div className="rqsts-list">
                                                                <p className="sub-tagline members-head">Requests</p>
                                                                {
                                                                    rqsts == 0
                                                                        ? <p>No requests</p>
                                                                        : (
                                                                            rqsts && rqsts.map((q) => (
                                                                                <div className="request">
                                                                                    <p className="room-name">{q.name}</p>
                                                                                    <div className="rqst-buttons">
                                                                                        <img onClick={(e) => { joinRoom(q, e) }} className="rqst" src={check} />
                                                                                        <img onClick={(e) => { deleteRqst(q, e) }} className="rqst" src={cancel} />
                                                                                    </div>
                                                                                </div>
                                                                            ))
                                                                        )

                                                                }
                                                            </div>
                                                        </div>
                                                        : null
                                                }
                                            </div>
                                            <div className='container'>

                                                {
                                                    roomY && roomY.map((r) => (
                                                        r.rid == roomId
                                                            ? r.ouid == auth.currentUser.uid
                                                                ? <button className="join log-out" onClick={deleteRoom} >Delete Room</button>
                                                                : <button onClick={leaveRoom} className="join log-out" >Leave room</button>
                                                            : null
                                                    ))
                                                }
                                                {
                                                    showGameBox
                                                        ? (
                                                            <>
                                                                <div className='header'>
                                                                    <p className='main'>TIC TAC TOE</p>
                                                                </div>
                                                                {
                                                                    turn == auth.currentUser.uid
                                                                        ? <p>Yout turn</p>
                                                                        : <p>Opponent's turn</p>
                                                                }
                                                                {
                                                                    boxes && boxes.map((b) => (
                                                                        <div id="game" className='game'>
                                                                            <div className='row1'>
                                                                                <img className='b1' src={b.box1src} id='box1' onClick={() => { clicked("box1", "box1src") }}></img>
                                                                                <img className='b1' src={b.box2src} id='box2' onClick={() => { clicked("box2", "box2src") }}></img>
                                                                                <img className='b1' src={b.box3src} id='box3' onClick={() => { clicked("box3", "box3src") }}></img>
                                                                            </div>
                                                                            <div className='row2'>
                                                                                <img className='b1' src={b.box4src} id='box4' onClick={() => { clicked("box4", "box4src") }}></img>
                                                                                <img className='b1' src={b.box5src} id='box5' onClick={() => { clicked("box5", "box5src") }}></img>
                                                                                <img className='b1' src={b.box6src} id='box6' onClick={() => { clicked("box6", "box6src") }}></img>
                                                                            </div>
                                                                            <div className='row3'>
                                                                                <img className='b1' src={b.box7src} id='box7' onClick={() => { clicked("box7", "box7src") }}></img>
                                                                                <img className='b1' src={b.box8src} id='box8' onClick={() => { clicked("box8", "box8src") }}></img>
                                                                                <img className='b1' src={b.box9src} id='box9' onClick={() => { clicked("box9", "box9src") }}></img>
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                }
                                                                <div className='result'>
                                                                    <p className='heading'>RESULT:</p>
                                                                    {
                                                                        roomY && roomY.map((rd) => (
                                                                            rd.rid == roomId
                                                                                ? <p className='resultp'>{rd.result}</p>
                                                                                : null
                                                                        ))
                                                                    }
                                                                </div>
                                                                {
                                                                    roomY && roomY.map((rr) => (
                                                                        rr.rid == roomId
                                                                            ? rr.ouid == auth.currentUser.uid
                                                                                ? <div className='restart'>
                                                                                    <img src={restart} className='restartButton' onClick={reload} />
                                                                                </div>
                                                                                : null
                                                                            : null
                                                                    ))
                                                                }
                                                            </>
                                                        )
                                                        : (
                                                            r.ouid == auth.currentUser.uid
                                                                ? <p className="sub-tagline" >Only you are here, please invite any one of your friends to play <br /> room id :- {r.rid}</p>
                                                                : <p className="sub-tagline">Admin removed you, please go the homepage and refresh</p>
                                                        )
                                                }

                                            </div>
                                        </div>
                                    </div>
                                    : <p className="sub-tagline">
                                        You haven't created this room. PLease ask the admin to join room<br />
                                        <button className="create" > Ask to join</button>
                                    </p>
                                : null

                        ))


                    )
            }

        </div>
    )
}

export default Room